import { OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { InspeccionService } from 'src/app/services/inspeccion.service';
import { ObservableInspService } from 'src/app/services/observable_insp';
var ResumenInspComponent = /** @class */ (function () {
    function ResumenInspComponent(dialog, observableService, _inspeccionService, _router, spinner) {
        this.dialog = dialog;
        this.observableService = observableService;
        this._inspeccionService = _inspeccionService;
        this._router = _router;
        this.spinner = spinner;
        this.urlZip = null;
        this.ingresando = false;
    }
    ResumenInspComponent.prototype.ngOnInit = function () {
        var _this = this;
        // CARGO DATA QUE UTILIZARÉ EN LA CREACION DE LA INSPECCIÓN
        this.correoDestroy = this.observableService.correo$.subscribe(function (corr) {
            _this.correo = corr;
            console.log('valor necesario ', _this.comentario);
        });
        this.usuarioDestroy = this.observableService.usuario$.subscribe(function (resp) {
            var fullRut = resp.split("-");
            _this.rutSolicitante = fullRut[0];
            _this.dvSolicitante = fullRut[1];
            console.log('usuario$.subscribe valor necesario ', _this.rutSolicitante);
        });
        this.direccionDestroy = this.observableService.direccion$.subscribe(function (dir) {
            _this.direccionSolicitante = dir;
            console.log('valor necesario ', _this.direccionSolicitante);
        });
        this.siglasIdDestroy = this.observableService.siglasId$.subscribe(function (sig) {
            // this.siglas = sig;
            _this.siglas = sig.toString().toLowerCase();
        });
        this.tiposInspDestroy = this.observableService.tiposInsp$.subscribe(function (sig) {
            _this.tipoInsp = sig;
            console.log('valor necesario ', _this.tipoInsp);
        });
        this.folioDireDestroy = this.observableService.folioDire$.subscribe(function (fol) {
            _this.folioDire = fol;
            console.log('valor necesario ', _this.folioDire);
        });
        this.folioPredioDestroy = this.observableService.folioPredio$.subscribe(function (pre) {
            _this.folioPredio = pre;
        });
        this.comentarioDestroy = this.observableService.comentario$.subscribe(function (com) {
            _this.comentario = com;
            // this.comentario = '<strong>Observación : </strong> <br> ';
            // const arr = com.split('');
            // console.log('com:: ', com);
            // const sum = 30;
            // let contador = sum;
            // for (let i = 0; i < arr.length; i++) {
            //   this.comentario += arr[i];
            //   if (i === contador) {
            //     this.comentario += '<br>';
            //     console.log('this.comentario:: ', this.comentario);
            //     contador = contador + sum;
            //     console.log('contador:: ', contador);
            //   }
            // }
            console.log('valor necesario ', _this.comentario);
        });
        //////////////////////////////////////////////////////////////
    };
    ResumenInspComponent.prototype.ngOnDestroy = function () {
        this.usuarioDestroy.unsubscribe();
        this.direccionDestroy.unsubscribe();
        this.siglasIdDestroy.unsubscribe();
        this.tiposInspDestroy.unsubscribe();
        this.folioDireDestroy.unsubscribe();
        this.folioPredioDestroy.unsubscribe();
        this.comentarioDestroy.unsubscribe();
    };
    ResumenInspComponent.prototype.crearSolicitudInspeccion = function () {
        var _this = this;
        this.spinner.show();
        // console.log('siglas', this.siglas);
        // console.log('tipos insp', this.tipoInsp);
        // console.log('rut sol', this.rutSolicitante, this.dvSolicitante);
        // console.log('direccion sol', this.direccionSolicitante);
        // console.log('folio predio', this.folioPredio);
        // console.log('folio dire ', this.folioDire);
        // console.log('comentario', this.comentario);
        this.ingresando = true;
        this.urlZip = localStorage.getItem("ZipURL");
        console.log('var url ', this.urlZip);
        this.dataInsert = [];
        this.dataInsert = this.dataInsert.concat({
            direccion: this.direccionSolicitante,
            folio_predio: this.folioPredio,
            folio_direccion: this.folioDire,
            rut_solicitante: this.rutSolicitante,
            dv_solicitante: this.dvSolicitante,
            siglas_id: this.siglas,
            observacion: this.comentario,
            tipo_insp: this.tipoInsp,
            url: this.urlZip,
            correo: this.correo
        });
        console.log('data::::', this.dataInsert);
        this._inspeccionService.crearInspeccion(this.dataInsert[0]).subscribe(function (response) {
            console.log('response complet', response);
            console.log('ahora ');
            localStorage.removeItem("archivos_marcados");
            localStorage.removeItem("ZipURL");
            localStorage.removeItem("adjuntos");
            _this.spinner.hide();
            _this.dialog.open(_this.finalizarMSG, { disableClose: true });
        }, function (error) {
            _this.spinner.hide();
            _this.ingresando = false;
            console.log(' NO GRABO RESPONSE', error);
            localStorage.removeItem("archivos_marcados");
            localStorage.removeItem("ZipURL");
            localStorage.removeItem("adjuntos");
            var alert = { icon: 'success', text: '', title: '' };
            alert.icon = 'alert';
            alert.text = '<p>Revise los datos ingresados.<br><br><br><br><br></p>';
            alert.title = 'ERROR';
            // this._router.navigate(['/inicio']);
        });
    };
    ResumenInspComponent.prototype.finalizarBTN = function () {
        this._router.navigate(["/inicio"]);
        this.dialog.closeAll();
    };
    return ResumenInspComponent;
}());
export { ResumenInspComponent };
